/**
 * Plays YouTube/Vimeo embeds inline within [data-video-playing-root] (no modal).
 */
class MediaInlineVideo extends HTMLElement {
  connectedCallback() {
    this.#playTrigger = this.querySelector('[data-play-trigger]');
    this.#playingRoot = this.closest('[data-video-playing-root]');
    this.#inlineVideo = this.#playingRoot?.querySelector('[data-inline-video]');

    this.#playTrigger?.addEventListener('click', this.#handlePlay);
  }

  /** @type {HTMLButtonElement | null} */
  #playTrigger = null;

  /** @type {HTMLElement | null} */
  #playingRoot = null;

  /** @type {HTMLElement | null} */
  #inlineVideo = null;

  #handlePlay = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.#playInline();
  };

  #playInline() {
    if (!this.#inlineVideo || !this.#playingRoot) return;

    const videoSrc = this.dataset.videoSrc;
    if (!videoSrc) return;

    let iframe = this.#inlineVideo.querySelector('iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.src = videoSrc;
      iframe.dataset.videoType = this.dataset.videoType ?? '';
      iframe.setAttribute('allow', 'autoplay; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('title', 'Video');
      iframe.className = 'inline-video__iframe';
      this.#inlineVideo.appendChild(iframe);
    }

    this.#inlineVideo.hidden = false;
    this.#playTrigger?.setAttribute('hidden', '');
    this.#playingRoot.classList.add('is-video-playing');
  }
}

if (!customElements.get('media-inline-video')) {
  customElements.define('media-inline-video', MediaInlineVideo);
}
